import type { ReactNode } from "react";
import { AuthProvider } from "@/features/auth/context/AuthContext";
import { Toaster } from "@/shared/components/ui/sonner";

interface AppProvidersProps {
  children: ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <AuthProvider>
      {children}
      <Toaster />
    </AuthProvider>
  );
}
